<template>
	<div class="wrapper">
		<ul class="select-option flex">
			<li>
				<span class="select-title">事件ID：</span>
				<el-input
					v-model="formData.caseId"
					placeholder="请输入事件ID"
					class="select-input"
					clearable
					@keyup.enter.native="search"
				/>
			</li>
			<li>
				<span class="select-title">申请人姓名：</span>
				<el-input
					v-model="formData.applicantName"
					placeholder="请输入申请人姓名"
					class="select-input"
					clearable
					@keyup.enter.native="search"
				/>
			</li>
			<li>
				<span class="select-title">受助人姓名：</span>
				<el-input
					v-model="formData.recRealName"
					placeholder="请输入受助人姓名"
					class="select-input"
					clearable
					@keyup.enter.native="search"
				/>
			</li>
			<li>
				<span class="select-title">受助人身份证号：</span>
				<el-input
					v-model="formData.recIdno"
					maxlength="18"
					placeholder="请输入受助人身份证号"
					class="select-input"
					clearable
					@keyup.enter.native="search"
				/>
			</li>
			<li>
				<span class="select-title">互助计划：</span>
				<el-select v-model="productIdArr" multiple placeholder="请选择" style="width: 390px" @change="productIdChange">
					<el-option v-for="item in productIdList" :key="item.id" :label="item.name" :value="item.id" />
				</el-select>
			</li>
		</ul>
		<ul class="select-option flex">
			<li>
				<el-button type="primary" icon="el-icon-search" :loading="loadingBtn" @click="search">
					查询
				</el-button>
			</li>
			<li>
				<el-button
					v-if="checkPermission('业管:批量发送邮件', permList)"
					type="primary"
					icon="el-icon-s-promotion"
					:loading="loadingBtn"
					:disabled="!selectRows.length"
					@click="resureSendEmail"
				>
					确认发送邮件
				</el-button>
			</li>
		</ul>

		<!-- <div style="margin: 25px 0">
			<el-pagination
				:page-size="tableData.size"
				:current-page="pageIndex"
				background
				layout="total,prev, pager, next, jumper"
				:total="tableData.total"
				@current-change="pageChange"
			/>
		</div> -->

		<el-table
			ref="multipleTable"
			:data="tableData.records"
			border
			style="width: 100%"
			@selection-change="selectionChange"
		>
			<el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center" />
			<el-table-column type="selection" width="60" align="center" />
			<el-table-column label="事件id" align="center" prop="caseId" width="150" />
			<el-table-column width="180" align="center" prop="createTime" label="报案日期" />
			<el-table-column align="center" prop="recRealName" label="受助人姓名" show-overflow-tooltip />
			<el-table-column align="center" prop="productName" label="所属计划" show-overflow-tooltip />
			<el-table-column align="center" prop="caseParentFlowName" label="事件状态" show-overflow-tooltip />
			<el-table-column align="center" prop="caseFlowName" label="当前处理状态" show-overflow-tooltip />
			<el-table-column align="center" prop="currentOperatorName" label="当前处理账号" show-overflow-tooltip />
			<el-table-column align="center" prop="endOperatorName" label="最后处理账号" show-overflow-tooltip />
			<el-table-column
				align="center"
				prop="adjustingUploadResultStatus"
				label="是否已完成公估回访"
				show-overflow-tooltip
				width="100"
			/>
			<el-table-column
				align="center"
				prop="customerComplaint"
				label="是否已完成客诉子任务"
				show-overflow-tooltip
				width="100"
			/>
			<el-table-column
				align="center"
				prop="feeCheckStatus"
				label="是否已完成去调查子任务"
				show-overflow-tooltip
				width="110"
			/>
			<el-table-column
				align="center"
				prop="companyAdjustingStatus"
				label="是否已完成公估子任务"
				show-overflow-tooltip
				width="100"
			/>
		</el-table>

		<!-- 弹窗组件 -->
		<resureDialog ref="resureDialogRef" :data="selectRows" :params="tableParams" @toRefreshListData="initListData" />
	</div>
</template>

<script>
import { mapState } from "vuex";
import resureDialog from "./resureDialog.vue";

export default {
	name: "SendMailOne",
	components: {
		resureDialog,
	},
	data() {
		return {
			loadingBtn: false, // 按钮的加载状态
			tableParams: {}, // 查询参数
			formData: {
				caseId: "", // 事件ID
				applicantName: "", // 申请人姓名
				productIds: "",
			},
			tableData: [], // 列表数据
			limit: 1000,
			pageIndex: 1,
			selectRows: [], // 选中的内容
			taskId: "", // 一键发送邮件的任务ID

			productIdList: [
				{
					id: "000000000101001",
					name: "抗癌互助计划（中青年版）",
				},
				{
					id: "000000000101005",
					name: "抗癌互助计划（老年版）",
				},
				{
					id: "000000000101004",
					name: "抗癌互助计划（少儿版）",
				},
				{
					id: "000000000101002",
					name: "意外互助计划",
				},
			],
			productIdArr: [],
			showResureDialog: false,
		};
	},

	computed: {
		...mapState({
			permList: (state) => state.permission.permList,
		}),
	},

	async created() {
		this.$emit("setCurrentMenu", "一键发送邮件功能");
		this.fetchCaseList();
	},

	methods: {
		/**
		 * 搜索列表
		 */
		search() {
			this.loadingBtn = true;
			this.fetchCaseList();
		},

		/**
		 * 列表表格序号
		 * @param {number} index
		 */
		indexMethod(index) {
			return (this.pageIndex - 1) * this.limit + index + 1;
		},

		/**
		 * 表格选择变化
		 * @param {number} rows
		 */
		selectionChange(rows) {
			this.selectRows = rows;
		},

		productIdChange(val) {
			this.formData.productIds = val.join(",");
		},

		/**
		 * 获取列表数据（待公示=>进入业管端）
		 * @description 默认加载999条数据
		 */
		async fetchCaseList() {
			const params = {
				accessRole: "ACCESS_ALL",
				flowCode: "102070",
				limit: this.limit,
				page: this.pageIndex,
				...this.formData,
			};
			this.tableParams = params;
			const res = await this.axios.get(`${this.homePath()}/async-task/mail/list`, { params });

			const result = res.data;
			if (result.status === "000000") {
				const pageData = result.page;
				this.loadingBtn = false;
				this.tableData = pageData;
				if (pageData.records.length) {
					await this.$nextTick();
					// 列表数据全选
					this.$refs.multipleTable.toggleAllSelection();
				}
			} else {
				this.$alert(result.message || "服务器繁忙，请稍后重试", "提示");
			}
		},

		resureSendEmail() {
			this.$refs.resureDialogRef.show();
		},

		/**
		 * 重新加载数据
		 * @description 筛选数据初始化
		 */
		async initListData() {
			Object.keys(this.formData).forEach((item) => {
				this.formData[item] = "";
			});
			await this.$nextTick();
			this.fetchCaseList();
		},

		pageChange(val) {
			this.pageIndex = val;
			this.fetchCaseList();
		},
	},
};
</script>

<style lang="scss" scoped>
.flex {
	display: flex;
	display: -webkit-flex;
	align-items: center;
}
.wrapper {
	.select-title {
		font-size: 14px;
		font-weight: 700;
	}
	.select-option {
		overflow: hidden;
		flex-wrap: wrap;
		margin: 0;
		li {
			float: none;
			margin: 0 15px 10px 0;
		}
	}
}
</style>
